<template>

    <Dialog v-model:visible="visible" modal header="K-line List" :style="{ width: '50vw' }">
        <DataTable :value="banData" :paginator="true" :rows="10" :responsiveLayout="'scroll'">
            <Column field="value" header="Value"></Column>
            <Column field="ban_type" header="Ban Type" :body="banTypeTemplate"></Column>
            <Column field="killed_by" header="Killed By" :body="killedByTemplate"></Column>
            <Column field="created_at" header="Created At" :body="createdAtTemplate"></Column>
            <Column header="Actions">
                <template #body="slotProps">
                    <Button label="Unban" icon="pi pi-user-plus" @click="deleteBan(slotProps.data.id)" size="small" />
                </template>

            </Column>
        </DataTable>
    </Dialog>
</template>

<script>


export default {
    name: 'BanTableDialog',

    data() {
        return {
            visible: false,
            banData: []
        };
    },
    methods: {
        /**
         * Receives ban data and displays the dialog.
         * @param {Array} data - Array of ban objects.
         */
        showTableDialog(data) {
            this.banData = data;
            this.visible = true;
        },

        /**
         * Handles dialog hide event.
         */
        onHide() {
            this.visible = false;
            this.banData = [];
        },

        /**
         * Maps ban type numbers to human-readable strings.
         * @param {Number} banType 
         * @returns {String}
         */
        getBanType(banType) {
            switch (banType) {
                case 1: return 'IP Address';
                case 2: return 'Username';
                case 3: return 'Fingerprint';
                default: return 'Unknown';
            }
        },


        /**
         * Formats the creation date.
         * @param {Object} rowData 
         * @returns {String}
         */
        createdAtTemplate(rowData) {
            const date = new Date(rowData.created_at);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        /**
         * Template for displaying ban type in the DataTable.
         * @param {Object} rowData 
         * @returns {String}
         */
        banTypeTemplate(rowData) {
            return this.getBanType(rowData.ban_type);
        },

        /**
         * Template for displaying the nickname of the user who issued the ban.
         * @param {Object} rowData 
         * @returns {String}
         */
        killedByTemplate(rowData) {
            return (rowData.nickname);
        },

        /**
         * Template for the action buttons in each row.
         * @param {Object} rowData 
         * @returns {VNode}
         */


        /**
         * Deletes a ban entry.
         * @param {Number} id 
         */
        deleteBan(id) {
            // Perform deletion logic here, such as an API call.
            // For this example, emit an event to the parent component.
            this.$socket.emit('kline-remove', {id: id});

            // Remove the deleted ban from the local data set.
            this.banData = this.banData.filter(ban => ban.id !== id);
        }
    }
};
</script>

<style scoped>
/* Optional styling */
</style>